export const config = {
         API: {
          URL: "https://api.pricecheckerapp.com",
           // URL: "http://localhost:3001",
         },
         CLIENTS: {
           URLIMG: "https://estaticos.isakitoweb.com.ar/wp-content/uploads",
         },
       };
